import {
  Wrapper,
  Top,
  Debug,
  Version,
  SuccessFont,
  ErrorFont,
} from './Footer.styles';
import { useRouter } from 'next/router';
import { usePolyglotT } from 'utils/locale/locale';
import { sanitizeHtml } from 'utils/sanitize';
import { routes } from 'utils/constants';
import { useTestable } from 'utils/testable/testable';
import { IS_PRODUCTION } from 'utils/check-environment/check-environment';
import packageInfo from '../../../../../package.json';

export const Footer = () => {
  const router = useRouter();
  const { testableFeaturesEnabled } = useTestable();
  const { t, helpLinks } = usePolyglotT();

  let topCopy;

  const defaultWebLinks = {
    webLink1: helpLinks.getting_started,
    webLink2: helpLinks.accessibility_tips,
  };

  switch (router.pathname) {
    case routes['/error']:
      topCopy = t('footer.generic_text', defaultWebLinks);
      break;

    case routes['/login']:
      topCopy = t('footer.login_text', defaultWebLinks);
      break;

    case routes['/forgotten-password']:
      topCopy = t('footer.generic_text', defaultWebLinks);
      break;

    case routes['/mfa-setup']:
      topCopy = t('footer.login_text', defaultWebLinks);
      break;

    case routes['/sso-redirect']:
      topCopy = t('footer.generic_text', defaultWebLinks);
      break;

    // signup page is not built yet
    // case routes['/signup']:
    //   topCopy = 'signup_text';
    //   break;

    // create-a-password page is not built yet
    // case routes['/create-a-password']:
    //   topCopy = 'signup_text';
    //   break;

    default:
      topCopy = t('footer.generic_text', defaultWebLinks);
      break;
  }

  return (
    <Wrapper data-testid='footer'>
      <Top
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(topCopy),
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            t('footer.bottom_text', {
              webLink1: helpLinks.user_terms,
              webLink2: helpLinks.privacy_policy,
            })
          ),
        }}
      />
      <Version data-testid='version'>{packageInfo.version}</Version>
      {!IS_PRODUCTION && (
        <Debug data-testid='debug'>
          {'Testable features enabled: '}
          {testableFeaturesEnabled() ? (
            <SuccessFont data-testid='testableValue'>true</SuccessFont>
          ) : (
            <ErrorFont data-testid='testableValue'>false</ErrorFont>
          )}
        </Debug>
      )}
    </Wrapper>
  );
};
